import Box from '@mui/material/Box';
import React from 'react';

import BottomNavigationBar from '../../components/Layouts/BottomNavigationBar/BottomNavigationBar';
import Footer from '../../components/Layouts/Footer/Footer';
import LayoutSingleColumn from '../../components/Layouts/LayoutSingleColumn';
import LayoutWrapperBottombar from '../../components/Layouts/LayoutWrapperBottombar/LayoutWrapperBottombar';
import LayoutWrapperFooter from '../../components/Layouts/LayoutWrapperFooter/LayoutWrapperFooter';
import LayoutWrapperMain from '../../components/Layouts/LayoutWrapperMain';
import LayoutWrapperTopbar from '../../components/Layouts/LayoutWrapperTopbar/LayoutWrapperTopbar';
import TopBar from '../../components/Layouts/TopBar/TopBar';
import Page from '../../components/Page/Page';

const mainSx = (theme) => ({
  minHeight: `calc(100vh - ${theme.globals.topBarHeightDesktopTotal}px)`,
});

/**
 * App chrome of a Storyblok-rendered page: `Page` (head/meta) around TopBar, the story body,
 * Footer and BottomNavigationBar.
 *
 * @param {object} props
 * @param {object} props.pageProps - props for `Page` (title, description, alternateLinks, ...)
 * @param {React.ReactNode} props.children - the rendered story
 */
const StoryPageLayout = ({ pageProps, children }) => (
  <Page {...pageProps}>
    <LayoutSingleColumn>
      <LayoutWrapperTopbar>
        <TopBar currentPage="StoryblokPage" />
      </LayoutWrapperTopbar>
      <LayoutWrapperMain>
        <Box sx={mainSx}>{children}</Box>
      </LayoutWrapperMain>
      <LayoutWrapperFooter>
        <Footer />
      </LayoutWrapperFooter>
      <LayoutWrapperBottombar>
        <BottomNavigationBar />
      </LayoutWrapperBottombar>
    </LayoutSingleColumn>
  </Page>
);

export default StoryPageLayout;
